import * as devisConf from '@/configuration/devisConf';
import cloneDeep from 'lodash/cloneDeep';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';

function getTotalHt(lignes) {
  return lignes
    .filter((el, index) => { return index > 0; })
    .map((el) => { return el.totalHt; })
    .reduce((a, b) => { return a + b; });
}

// cette soulte et paprticuliere car elle adapte le montant uniquement sur la premiere ligne
export default function calculRemiseMultiProduitWithSoult(
  informationRemiseToApply, lignes, dcf,
) {
  // on applique les remises à toutes les lignes sauf la premiere car
  // c'est sur la premiere ligne que l'on applique l'algo

  if (lignes.length === 1) { // si une seul ligne pas besoin de soult donc on aplique sur tout
    lignes[0].lignesRemise = cloneDeep(informationRemiseToApply.lignesRemise);
    lignes[0].remise = cloneDeep(informationRemiseToApply.remise);
    calculCommandeDevis(dcf);
    return;
  }

  // on applique les lignes de remise sur les lignes sauf la premiere
  lignes.forEach((ligne, index) => {
    ligne.typeRemise = devisConf.PERSONALISE;
    if (index > 0) {
      ligne.lignesRemise = cloneDeep(informationRemiseToApply.lignesRemise);
      ligne.remise = cloneDeep(informationRemiseToApply.remise);
    } else {
      ligne.lignesRemise = [];
      ligne.remise = 0;
    }
  });
  // on calcul pour avoir toutes les lignes remisé et juste la premiere non remisé
  calculCommandeDevis(dcf);

  // gestion de la ligne qui doit etre soult
  if (informationRemiseToApply.lignesRemise.length > 0 && lignes.length > 1) {
    informationRemiseToApply.lignesRemise.forEach((remise, index) => {
      // on prend le montant que doit avoir la premiere ligne par rapport à la bonne remise
      const montantWithoutFirstLigne = informationRemiseToApply.listeMontant[index]
        - getTotalHt(lignes);

      const remiseSoulted = cloneDeep(remise);
      if (remise.isModeAAtteindre) {
      // on recupere le % de remise / majoration de la ligne qui est soulte
        remiseSoulted.remise = Number((((montantWithoutFirstLigne / lignes[0].totalHt) - 1) * 100)
          .toFixed(5));
      }
      // on remet en place le signe selon majoration ou remise (si on le perd)
      if (remise.remise > 0 && remiseSoulted.remise < 0) {
        remiseSoulted.remise = Math.abs(remiseSoulted.remise);
      }
      if (remise.remise < 0 && remiseSoulted.remise > 0) remiseSoulted.remise *= -1;

      // on ajoute la remise, on calcul et on passe à la suivante si il y en a
      lignes[0].lignesRemise.push(remiseSoulted);
      calculCommandeDevis(dcf);
    });
  }
}
